import {ReferenceType, ValueType} from "src/app/constant/Enums";
import {StringUtil} from "src/app/util/StringUtil";
import {UpdateReviewRequest} from "src/app/api/model/request/UpdateReviewRequest";
import axios from "axios";
import {QueryCondition} from "src/app/model/QueryCondition";
import {DecisionInput} from "src/app/model/DecisionInput";
import {LastEvaluatedKey} from "src/app/model/LastEvaluatedKey";
import {ListReviewRequest} from "src/app/api/model/request/ListReviewRequest";
import {ExportReviewRequest} from "src/app/api/model/request/ExportReviewRequest";
import {GetReviewRequest} from "src/app/api/model/request/GetReviewRequest";
import {saveAs} from "file-saver";
import userInfoStore from "src/app/store/UserInfoStore";
import {GenericValue} from "src/app/model/GenricValue";

const AUDITOR_INPUT_KEY = "auditorInput";
const COMMENT_KEY = "comment";
const REASON_CODE_KEY = "reasonCode";
const ROOT_CAUSE_KEY = "rootCause";
const REOPEN_TICKET_KEY = "appealTicket";
const START_TIME_KEY = "startTime";
const END_TIME_KEY = "endTime";

export namespace ApiUtil {

    export function createUpdateReviewRequest(reviewId: string, rawDecision: DecisionInput,
                                              startTime: string | null, endTime: string | null) {
        const {reason, rootCause, reviewStatus, reviewResult, comment, auditorInputs, reOpenFor, appealTicket} = rawDecision;
        const decision: Map<string, GenericValue> = new Map<string, GenericValue>();
        if (startTime != undefined && !StringUtil.isNullOrEmpty(startTime)) {
            decision.set(START_TIME_KEY, {
                jsonVal: startTime,
                type: ValueType.SINGLE_ITEM,
            });
        }
        if (endTime != undefined && !StringUtil.isNullOrEmpty(endTime)) {
            decision.set(END_TIME_KEY, {
                jsonVal: endTime,
                type: ValueType.SINGLE_ITEM,
            });
        }
        if (reason != undefined && !StringUtil.isNullOrEmpty(reason)) {
            decision.set(REASON_CODE_KEY, {
                jsonVal: reason,
                type: ValueType.SINGLE_ITEM,
            });
        }

        if (rootCause != undefined && !StringUtil.isNullOrEmpty(rootCause)) {
            decision.set(ROOT_CAUSE_KEY, {
                jsonVal: rootCause,
                type: ValueType.SINGLE_ITEM,
            });
        }

        if (appealTicket != undefined && !StringUtil.isNullOrEmpty(appealTicket)) {
            decision.set(REOPEN_TICKET_KEY, {
                jsonVal: appealTicket,
                type: ValueType.SINGLE_ITEM,
            });
        }

        if (comment != undefined && !StringUtil.isNullOrEmpty(comment)) {
            decision.set(COMMENT_KEY, {
                jsonVal: comment.trim(),
                type: ValueType.SINGLE_ITEM,
            });
        }

        if (auditorInputs != undefined && auditorInputs.size > 0) {
            const finalInputs = new Map<string, string>();
            auditorInputs.forEach((value, key) => {
                if (!StringUtil.isNullOrEmpty(value)) {
                    finalInputs.set(key, value);
                }
            })
            if (finalInputs.size > 0) {
                decision.set(AUDITOR_INPUT_KEY, {
                    jsonVal: JSON.stringify(auditorInputs),
                    type: ValueType.MAP
                });
            }
        }

        const request: UpdateReviewRequest = {
            reviewId: reviewId,
            reviewStatus: reviewStatus,
            reviewResult: reviewResult,
            reOpenFor: reOpenFor,
            decisionDetail: mapToObject(decision),
            modifiedBy: userInfoStore.value
        };
        return request;
    }

    export function createListReviewRequest(queryCondition: QueryCondition, lastEvaluatedKey: LastEvaluatedKey | undefined) {
        const request: ListReviewRequest = {
            referenceType: ReferenceType.TRANSPORTER,
            referenceSubType: queryCondition.referenceSubType,
            caseType: queryCondition.caseType,
            caseSubType: queryCondition.caseSubType,
            country: queryCondition.country,
            reviewStatus: queryCondition.reviewStatus,
            reviewType: queryCondition.reviewType,
            startDateUtc: new Date(queryCondition.startDate).getTime(),
            endDateUtc: new Date(queryCondition.endDate).getTime()
        };
        if (lastEvaluatedKey != undefined) {
            request.lastEvaluatedKey = lastEvaluatedKey;
        }
        return request;
    }

    export function createExportReviewRequest(queryCondition: QueryCondition) {
        const request: ExportReviewRequest = {
            referenceType: ReferenceType.TRANSPORTER,
            referenceSubType: queryCondition.referenceSubType,
            caseType: queryCondition.caseType,
            caseSubType: queryCondition.caseSubType,
            country: queryCondition.country,
            reviewStatus: queryCondition.reviewStatus,
            reviewType: queryCondition.reviewType,
            startDateUtc: new Date(queryCondition.startDate).getTime(),
            endDateUtc: new Date(queryCondition.endDate).getTime()
        };
        return request;
    }

    export function createGetReviewRequest(reviewId: string) {
        const request: GetReviewRequest = {
            reviewId: reviewId
        };
        return request;
    }

    export async function downloadFile(url: string, fileName: string) {
        try {
            const response = await axios.get(url, {
                responseType: 'blob',
            });
            const blob = new Blob([response.data], {type: 'text/csv'});
            saveAs(blob, fileName);
        } catch (error) {
            // todo: add more specific error handling logic here, like re-try strategy
            console.error('Error downloading the file:', error);
        }
    }

    function mapToObject<K extends string | number | symbol, V>(map: Map<K, V>): Record<K, V> {
        const obj: Record<K, V> = {} as Record<K, V>;
        map.forEach((value, key) => {
            obj[key] = value;
        });
        return obj;
    }

}